import { NgModule } from '@angular/core';
import { InputComponent } from './input.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorModule } from '../form-error/form-error.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { PreventScrollModule } from 'common/directives/preventScroll/prevent-scroll.module';

@NgModule({
    imports: [IonicModule, CommonModule, ReactiveFormsModule, FormErrorModule, TooltipModule, PreventScrollModule],
    declarations: [InputComponent],
    exports: [InputComponent],
})
export class InputModule {}
